import { VendorMetadata } from "../type";

import { Vendor } from "./data";

export const Vowkey: VendorMetadata = Object.freeze({
  id: Vendor.vowkey,
  name: "Vowkey",
});
